<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
export default {
  mixins: [Api, Sabit],
  props: ["Icdegerid"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
    };
  }, 
  methods: {
    Get() {
      let Filter = "&Icdegerid=" + this.Icdegerid;
      this.ActionsFilterGet({Service:"StrIcDegerBirim", Page:this.Page, Filter:Filter}).then(
        (res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;
        }
      );
    },
  },
};
</script>
<template>
  <div>  
    <table class="table table-striped table-bordered mb-0">
                <thead>
                  <tr> 
                    <th scope="col">
                      {{ $t("StrIcDegerBirim.Table.Birimid") }}
                    </th>  
                    <th scope="col" style="width: 85px; text-align: center; vertical-align: middle;">
                      {{ $t("StrIcDegerBirim.Table.Islem") }}
                    </th>
                  </tr>
                </thead>
                <tbody
                  v-for="TableDataVerileri in TableData"
                  :key="TableDataVerileri.Id"
                >
                  <tr> 
                    <td>{{ TableDataVerileri.BirimAdis.join(", ") }}</td> 
                    <td style="width: 85px; text-align: center; vertical-align: middle;">
                      <b-button-group>
                        <b-button variant="success" v-b-modal.StrIcDegerBirim @click="$emit('Icdegerid', TableDataVerileri.Icdegerid)"><i class="fas fa-pencil-alt"></i></b-button>
                        <b-button variant="danger" @click="Delete('StrIcDegerBirim', TableDataVerileri.Id)"><i class="fa fa-trash-alt"></i></b-button>
                      </b-button-group>
                    </td>
                  </tr> 
                </tbody>
              </table>
  </div>
</template>
